import Button from "@metacrm/metacrm-material-ui/dist/Button";
import Switch from "@metacrm/metacrm-material-ui/dist/Switch";
import { Box } from "@mui/material";
import axios from "axios";
import config from "config";
import { apiUrl } from "features/configure";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";
import { useIntl } from "react-intl";

export default function XShareMenu({ initPublic }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isPublic, setIsPublic] = useState(initPublic);
  const [entityName] = useOutletContext();
  const { campaignId } = useParams();
  const { formatMessage } = useIntl();

  useEffect(() => {
    setIsPublic(initPublic);
  }, [initPublic]);

  const dispatchSnackbar = useDispatchSnackbar();
  const copyFn = useCopyToClipboard(
    `${config.portalUrl}/x/shared/${entityName}/${campaignId}`,
    <Box className="item-flex" gap="4px">
      <Box sx={{ lineHeight: "normal" }}>
        {formatMessage({ id: "global.status.successfullyCopied" })}
      </Box>
    </Box>
  );

  async function handleShowPublic(value) {
    try {
      await axios.post(
        `${apiUrl}/api/x/${entityName}/campaign/${campaignId}/shared`,
        {
          shared: value,
        }
      );
      setIsPublic(value);
    } catch (err) {
      dispatchSnackbar({ err });
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <Button
        variant="text"
        onClick={() => setIsOpen(true)}
        className="item-flex"
        sx={{
          cursor: "pointer",
          gap: "4px",
          fontSize: "14px",
          padding: "0 8px",
          height: "fit-content",
          color: isOpen ? "#7B61FF" : "#A5A5A5",
          minWidth: "70px",
        }}
      >
        <i className="meta-crm-icon-ic_share_alt font-size-14" />
        {formatMessage({ id: "global.btn.share" })}
      </Button>
      {isOpen && (
        <>
          <Box
            sx={{
              position: "absolute",
              top: "20px",
              right: 0,
              width: "320px",
              bgcolor: "white",
              zIndex: 100000,
              borderRadius: "8px",
              boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.10)",
              p: "16px",
            }}
          >
            <Box className="item-flex" justifyContent="space-between">
              <Box>
                <Box color="#555" fontSize="14px">
                  {formatMessage({ id: "global.status.public" })}
                </Box>
                <Box color="#777" fontWeight={400} mt="8px">
                  {formatMessage({ id: "global.permission.anyoneCanView" })}
                </Box>
              </Box>
              <Switch
                onChange={(v) => handleShowPublic(v)}
                checked={isPublic}
                iosSwitch
              />
            </Box>
            <Button
              variant="outlined"
              sx={{ width: "100%", mt: "14px", fontWeight: 700 }}
              onClick={copyFn}
              disabled={!isPublic}
            >
              <i className="meta-crm-icon-ic_link2 font-size-16" />
              <Box fontSize={12} ml="4px">
                {formatMessage({ id: "global.btn.copyLink" })}
              </Box>
            </Button>
          </Box>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "rgba(0,0,0,0.5)",
              zIndex: 99999,
            }}
            onClick={() => setIsOpen(false)}
          />
        </>
      )}
    </div>
  );
}
